var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsJobSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1793 38.4999H17.609C11.0365 38.4999 7.75117 38.4999 5.70884 36.4191C3.6665 34.3383 3.6665 30.9888 3.6665 24.2916C3.6665 17.5944 3.6665 14.2449 5.70884 12.1641C7.75117 10.0833 11.0365 10.0833 17.609 10.0833H24.5812C31.1537 10.0833 34.4408 10.0833 36.4832 12.1641C38.0543 13.7646 38.4155 16.1168 38.4998 20.1666",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6975 36.7088L40.333 40.3333M29.333 10.0833L29.1497 9.51496C28.2422 6.69163 27.7893 5.27996 26.7095 4.47329C25.6278 3.66663 24.1942 3.66663 21.3213 3.66663H20.8392C17.97 3.66663 16.5345 3.66663 15.4547 4.47329C14.373 5.27996 13.9202 6.69163 13.0127 9.51496L12.833 10.0833M38.5968 32.131C38.6113 31.2728 38.4547 30.4203 38.1363 29.6232C37.8179 28.8262 37.344 28.1005 36.7422 27.4885C36.1404 26.8765 35.4228 26.3904 34.6312 26.0586C33.8396 25.7268 32.9899 25.5559 32.1316 25.5559C31.2733 25.5559 30.4236 25.7268 29.632 26.0586C28.8404 26.3904 28.1228 26.8765 27.521 27.4885C26.9192 28.1005 26.4453 28.8262 26.1269 29.6232C25.8084 30.4203 25.6519 31.2728 25.6663 32.131C25.6949 33.8268 26.3886 35.4435 27.598 36.6327C28.8073 37.8219 30.4355 38.4883 32.1316 38.4883C33.8277 38.4883 35.4558 37.8219 36.6652 36.6327C37.8746 35.4435 38.5683 33.8268 38.5968 32.131Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsJobSearch);
export default __webpack_public_path__ + "static/media/hugeicons_job-search.fbbaf8a7210dfbd4812ed83f712692ad.svg";
export { ForwardRef as ReactComponent };